module.exports = __webpack_public_path__ + "img/direction.4016835c.svg";